<template>
     <el-carousel v-if="$i18n.locale != 'en'?PhotoList_CN.length>0:PhotoList_EN.length>0" class="carousel-image" type="image" ref="carousel" :autoplay="true" indicator-position="none">
      <el-carousel-item  v-for="(item, index) in $i18n.locale != 'en'?PhotoList_CN:PhotoList_EN" :key="index">
        <el-image fit="fill" :src="
          item.picUrl?item.picUrl:defultUrl" :onerror="defaultImg"  @click="picClick(item)">
        </el-image>
      </el-carousel-item>
    </el-carousel>
</template>
  
  <script>
  import { getActivityListByCustomer } from "@/api/platformData.js";
  export default {
    name: "Carousel",
    data() {
      return {
        PhotoList_CN: [],
        PhotoList_EN: [],
        defultUrl: require('@/assets/img/hotel_img_error.png'),
        defaultImg: 'this.src="' + require("@/assets/img/hotel_img_error.png") + '";this.onerror=null;',
      };
    },
    props: {
      adsType: Number,
    },
    mounted() {
      if(this.$objBaseInfo.sourceType == "OBT" && this.$objBaseInfo.channelId == 'WEB'){
        this.getActivityList();
      }
    },
    methods: {
      getActivityList(){
        var searchParam ={
          params:{
            adsType: this.adsType,
            customerCode: this.$objBaseInfo.customerCode,
          }
        }
        this.PhotoList_CN = [];
        this.PhotoList_EN = [];
        getActivityListByCustomer(searchParam)
        .then((res) =>{
          sessionStorage.setItem("AdStatus", "0");
          //sessionStorage.setItem("AdStatus", "0");
          if(res.code == 200){
            for(var i = 0; i < res.data.adsPageInfos.adsDetails.length; i++){
              sessionStorage.setItem("AdStatus", "1");
              //sessionStorage.setItem("AdStatus", "1");
              var data =res.data.adsPageInfos.adsDetails[i];
                if(this.$objBaseInfo.channelId == 'WEB'){
                  if(data.pcAds.enPicUrl !=undefined && data.pcAds.enPicUrl != ""){
                    this.PhotoList_EN.push({
                        picUrl: data.pcAds.enPicUrl,
                        fileUrl: data.pcAds.enFileUrl,
                    })
                  }
                  if(data.pcAds.cnPicUrl !=undefined && data.pcAds.cnPicUrl != ""){
                    this.PhotoList_CN.push({
                        picUrl: data.pcAds.cnPicUrl,
                        fileUrl: data.pcAds.cnFileUrl,
                    })
                  }
                }else{
                  if(data.pcAds.enPicUrl !=undefined && data.pcAds.enPicUrl != ""){
                    this.PhotoList_EN.push({
                        picUrl: data.h5Ads.enPicUrl,
                        fileUrl: data.h5Ads.enFileUrl,
                    })
                  }
                  if(data.pcAds.cnPicUrl !=undefined && data.pcAds.cnPicUrl != ""){
                    this.PhotoList_CN.push({
                        picUrl: data.h5Ads.cnPicUrl,
                        fileUrl: data.h5Ads.cnFileUrl,
                    })
                  }
                }
            }
          }
      });
    },
    picClick(val){
        var url = val.fileUrl;
        if(url != undefined && url != ""){
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.click();
        }
    },
    },
    
  };
  </script>
  <style lang="stylus" scoped>
  @media screen and (max-width: 960px) {
    
  }
  @media screen and (min-width: 961px) {
    .carousel-image{
        overflow: hidden;
    }
    ::v-deep .el-carousel__container {
      height: 10.3rem;
    }
    ::v-deep .el-carousel__container {
      height: 10.3rem;
    }
  }
  </style>
  